<script lang="ts" setup>
import { readonly, toRef } from 'vue';

import { provideMenuContext } from './context';

export interface MenuContextProviderProps {
  dataTestid?: string;
  registerMenuGroup: (id: symbol) => void;
  deregisterMenuGroup: (id: symbol) => void;
  focusTrigger?: () => void;
}

const props = defineProps<MenuContextProviderProps>();

provideMenuContext({
  dataTestid: readonly(toRef(props, 'dataTestid')),
  registerMenuGroup: props.registerMenuGroup,
  deregisterMenuGroup: props.deregisterMenuGroup,
  focusTrigger: props.focusTrigger,
});
</script>

<template>
  <slot />
</template>
